export default __webpack_public_path__ + "static/workout-app-f8703e84578c7e386c95342adc4226e4.png";